import(/* webpackMode: "eager", webpackExports: ["Canvas"] */ "C:\\Users\\memo-disparo\\Desktop\\Page_v2\\app\\components\\canvas\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\memo-disparo\\Desktop\\Page_v2\\app\\components\\me\\index.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\memo-disparo\\Desktop\\Page_v2\\node_modules\\next\\font\\google\\target.css?{\"path\":\"app\\\\page.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "C:\\Users\\memo-disparo\\Desktop\\Page_v2\\app\\page.module.css");
